import { render, staticRenderFns } from "./Comportamiento.vue?vue&type=template&id=1b09586d"
import script from "./Comportamiento.vue?vue&type=script&lang=js"
export * from "./Comportamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports